import klarnaLogo from "src/assets/klarna.png";
import { NewTabLink } from "src/components/NewTabLink";
import EnrolNowButton from "src/newComponents/buttons/EnrolNowButton";
import RoutedButton from "src/newComponents/buttons/RoutedButton";

const HowItWorksContent = () => {
  return (
    <div>
      <p>
        Pre-Reg Shortcuts is a leading Pharmacy education platform created by Pharmacists Marvin Munzu and Umar Majid in
        2016. Both Pharmacists recognised a need for better online support for Trainee Pharmacists (Pre-Reg's back
        then). Over the last decade, they've created innovative GPhC exam revision courses, and are now a household name
        with their Foundation Pharmacist Training Programme.
      </p>

      <p>
        At Pre Reg Shortcuts, you'll find engaging GPhC exam revision resources and all content we offer is mapped to
        the GPhC framework and up to date. If you're looking for interactive content to make your exam revision easier,
        you're in in the perfect place!
      </p>

      <p>
        Whilst we specialise in supporting Trainee Pharmacists with the Foundation Pharmacist Training Year and GPhC
        exam revision, our resources are also very popular with students and Pharmacists too who are searching for
        university revision and refresher courses.
      </p>

      <p>
        At Pre Reg Shortcuts, all the content we offer is mapped to the GPhC framework and up to date. If you're looking
        for interactive content to make your exam revision easier, you're in in the perfect place!
      </p>

      <h3>Join Us Now - It's FREE</h3>

      <p>
        Not sure where to begin your exam revision? Interested in a preview of our resources before enrolling with us?
        Create your free account now and unlock free access to Pharmacy exam revision resources today!
      </p>

      <RoutedButton path="/join-us/" buttonColor="inherit" size="large">
        Join Us - It's FREE
      </RoutedButton>

      <h3>Which programme / exam revision courses should I choose?</h3>

      <p>Ready to start your Foundation Pharmacist Training Year and GPhC exam revision but not sure where to start?</p>

      <p>Our options include:</p>
      <p>
        <NewTabLink href="/programme/">Foundation Pharmacist Training Programme</NewTabLink>: If you're interested in
        everything we offer enrol on our all in one programme
      </p>
      <p>
        Prefer to study in your own time? Select <NewTabLink href="/courses/">Exam Revision Courses</NewTabLink>,{" "}
        <NewTabLink href="/question-bank/">Question Bank</NewTabLink>,{" "}
        <NewTabLink href="/mock-paper/">Mock Paper</NewTabLink>
      </p>

      <h3>Monthly instalment options</h3>

      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <img src={klarnaLogo} alt="Klarna" title="Klarna" style={{ width: "70px", height: "39px" }} loading="eager" />
        <p>
          No need to purchase up front, spread your purchase over 12 months with no interest and no deposit.{" "}
          <NewTabLink href="https://www.klarna.com/uk/terms-and-conditions/">T&C's</NewTabLink> apply. For more info
          contact our support team
        </p>
      </div>

      <h3>Enrolment process</h3>

      <p>
        Interested in enrolling with Pre Reg Shortcuts? Create your account and enrol on our programme / exam revision
        courses follow the steps below:
      </p>

      <p>
        <strong>Step 1:</strong> Browse our entire range of products <NewTabLink href="/products/">here</NewTabLink>,
        you can view our Foundation Pharmacist Training Programme and Exam Revision Courses.
      </p>

      <p>
        <strong>Step 2:</strong> Add your selected programme / courses to basket, then select proceed to payment and
        follow the on screen instructions to create your login details.
      </p>
      <p>
        <strong>Step 3:</strong> Complete purchase and follow the email instructions to create your password, then login
        to your account.
      </p>
      <p>
        <strong>Step 4:</strong> After you login in, visit 'Programme' on our platform, and your purchases will unlock
        in your account automatically. Access duration to your account lasts for 365 days from the day you enrol.
      </p>

      <p>
        Reminder: You can now enrol with preregshortcuts with monthly instalment options with no deposit and no
        interest, full access to your account straight away after enrolment, and split your payments over 12 months.
        Select Klarna at the checkout to view instalment options available to you.{" "}
        <NewTabLink href="https://www.klarna.com/uk/terms-and-conditions/">Klarna T&C's</NewTabLink> apply, for more
        info contact our support team
      </p>

      <EnrolNowButton />

      <h3>Telegram support group (Lifetime Access)</h3>
      <p>
        Available to any Trainees who enrol on our{" "}
        <NewTabLink href="/foundation-training-programme/">Foundation Pharmacist Training Programme</NewTabLink> only,
        you will receive email instructions on how to join after you enrol.
      </p>
    </div>
  );
};

export default HowItWorksContent;
